import { FC } from 'react'

import { Title } from '.'

type TitleMainProps = {
  className?: string,
  background?: number,
  title?: string
}

const TitleMain:FC<TitleMainProps> = ({ title = 'Mi Portal INDISA', background = 1, className = '' }) => {
  return(
    <div className={`title-main ${background ? 'title-main--bg-' + background : ''} ${className}`}>
      <Title component="h2" size="32" color="whites" weight="bold" className="lg:fz-24">{title}</Title>
    </div>
  )
}

export { TitleMain }